import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2.5),
		height: "100%",
		maxWidth: "100%",
		width: "100%",
		overflowX: "hidden",
		backgroundColor: theme.palette.fancyBackground,
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1.25),
			height: "100%",
			paddingBottom: "calc(12px + env(safe-area-inset-bottom, 0px))",
		},
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
		width: "100%",
		overflowX: "hidden",
	},
	mobileScroll: {
		[theme.breakpoints.down("sm")]: {
			overflowY: "auto",
			WebkitOverflowScrolling: "touch",
			"& > *": { flexShrink: 0 },
			"& > .MuiPaper-root": { flex: "0 0 auto", minHeight: 240, overflow: "visible" },
		},
	},
	flow: {
		height: "auto",
		minHeight: "100%",
		overflow: "visible",
	},
}));

const MainContainer = ({ children, mobileScroll = false, flow = false }) => {
	const classes = useStyles();

	return (
		<Container className={`${classes.mainContainer} ${flow ? classes.flow : ""}`} maxWidth={false}> {/* ✅ maxWidth={false} para permitir ancho completo */}
			<div className={`${classes.contentWrapper} ${flow ? classes.flow : ""} ${mobileScroll ? classes.mobileScroll : ""}`}>{children}</div>
		</Container>
	);
};

export default MainContainer;
